import { useTranslation } from "react-i18next";
import { PersonInfoCard } from "@/common";
import { useAppSelector } from "@/services/store";
import { currentPersonSelector } from "@/pages/ContactsPage/slice";
import { transformSDateToString } from "@/shared/utils";
import { handleFullName } from "@/shared/utils/handle-contacts-null";
import { useRuntimeImage } from "@/entities/runtime-image";
import type { FC } from "react";
import type { PersonInfoCardProps } from "@/common/PersonInfoCard/types";
import styles from "./styles.module.scss";

export type PersonCardProps = {
  isEdit?: boolean;
  showMobileMenu?: boolean;
  showEdit?: boolean;
  form?: boolean;
} & Pick<PersonInfoCardProps, "avatarIsEditable">;

export const PersonCard: FC<PersonCardProps> = ({ isEdit, showMobileMenu, ...props }) => {
  const { t } = useTranslation();

  const currentPerson = useAppSelector(currentPersonSelector);
  const { getRuntimeImageURL } = useRuntimeImage();

  if (!currentPerson) return <div className={styles.card}>{t("common.noData")}</div>;

  return (
    <PersonInfoCard
      showMobileMenu={showMobileMenu}
      className={styles.card}
      isEdit={isEdit}
      content={{
        group: currentPerson.group,
        birthday: transformSDateToString(currentPerson?.birthdaySDate),
        birthdaySDate: currentPerson?.birthdaySDate,
        id: currentPerson.id,
        image: getRuntimeImageURL({ fileId: currentPerson.avatarFile?.fileId ?? "" }),
        name: handleFullName(
          currentPerson?.firstName,
          currentPerson?.lastName,
          currentPerson?.middleName,
        ),
        tags: currentPerson.tags[0]?.name,
        work: currentPerson.title ?? "",
        gender: currentPerson.gender,
      }}
      {...props}
    />
  );
};
